import React from 'react'

import FlatButton from 'material-ui/FlatButton'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'

import { connect } from 'react-redux'

import ModulesUtils from 'infra/ModulesUtils.js'
import FunctionUtils from 'lambda/FunctionUtils.js'

import RecurrenceDialog from './RecurrenceDialog'

import moment from 'moment'

class RecurrenceView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openDialog: false,
      openPopover: false
    }
  }

  deleteInstance() {
    FunctionUtils.deleteInstance(this.props.teamId,
      this.props.jobInfo, this.props.dateStr);

    // Close JobScreen
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: { }
    })

    this.setState({openPopover: false})
  }

  deleteInstanceAndCreate() {
    this.deleteInstance();
    this.createInstanceCopy();
  }

  createInstanceCopy() {
    const ccModules = JSON.parse(JSON.stringify(
      this.props.jobInfo.modules));
    delete ccModules.tasksInstance;
    delete ccModules.tasksRecurrent;
    ccModules.tasks = { _type: 'shared' }
    ccModules.date = { _type: 'initial' }
    ccModules.displayName.value =
      (ccModules.displayName.value || '') + ' (copy)'

    // Open new Job Creation
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: "ADD_JOB",
      value: {
        dateStr: this.props.dateStr,
        modules: ccModules,
        clone: true
      }
    });
  }

  deleteFutureInstances() {
    FunctionUtils.changeDateModuleWithDates(
      this.props.teamId,
      this.props.jobInfo,
      this.props.jobInfo.modules.date.startDate,
      moment(this.props.dateStr).subtract(1, 'days').format('YYYY-MM-DD'));

    this.setState({openPopover: false})
  }

  deleteFutureInstancesAndCreate() {
    this.deleteFutureInstances();

    const ccModules = JSON.parse(JSON.stringify(
      this.props.jobInfo.modules));
    ccModules.displayName.value =
      (ccModules.displayName.value || '') + ' (copy)'

    // Open new Job Creation
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: "ADD_JOB",
      value: {
        dateStr: this.props.dateStr,
        modules: ccModules,
        clone: true
      }
    });
  }

  render() {
    const recurrence = this.props.dateInfo.recurrence;
    if (!recurrence) {
      return null;
    }

    const summaryText = ModulesUtils.getRecurrenceSummary(this.props.dateInfo);

    return (
      <div
        style={{ display: 'flex', flexDirection: 'column' }}>

        <div
          style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 8 }}>

          <span
            style={{ color: '#757575', marginRight: 8 }}>
            {summaryText}
          </span>

          <FlatButton
            ref='editButton'
            label="Edit"
            onTouchTap={(event) => {
              if (this.props.isNewJob) {
                this.setState({ openDialog: true })
              } else {
                this.setState({
                  anchorEl: event.currentTarget,
                  openPopover: true
                })
              }
            }}/>

          <RecurrenceDialog
            dateInfo={this.props.dateInfo}
            open={this.state.openDialog}
            onSave={this.props.onSave}
            onClose={() => this.setState({ openDialog: false })}/>

        </div>

        <Popover
          open={this.state.openPopover}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
          onRequestClose={() => this.setState({openPopover: false})}>
          <Menu>
            <MenuItem
              key={'NEW_COPY_INSTANCE'}
              onTouchTap={this.createInstanceCopy.bind(this)}
              primaryText={'Create a copy of this instance'}/>
            <MenuItem
              key={'DELETE_INSTANCE_AND_CREATE'}
              onTouchTap={this.deleteInstanceAndCreate.bind(this)}
              primaryText={'Delete this instance & create a copy'}/>
            <MenuItem
              key={'DELETE_FUTURE_AND_CREATE'}
              onTouchTap={this.deleteFutureInstancesAndCreate.bind(this)}
              primaryText={'Delete future events & create a new recurrent event'}/>
          </Menu>
        </Popover>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    teamId: state.firebase.team.metadata.value.id
  }
}

export default connect(mapStateToProps)(RecurrenceView)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/RecurrenceView.js